import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Fullscreen from 'react-full-screen';
import {Helmet} from "react-helmet";
import { getFromLocalStorage } from '../../services/utils';
import Loading from '../Loading';
import OrderCategoryItems from './OrderCategoryItems';
import InOutletSubHeadingWrapper from './InOutletSubHeadingWrapper';
import DeliverySubHeadingWrapper from './DeliverySubHeadingWrapper';
import IncomingItems from './IncomingItems';
import InstaServiceProduction from './InstaServiceProduction';
import InstaServiceCurrentStock from './InstaServiceCurrentStock';
import Webcam from 'react-webcam';
import BarcodeReader from 'react-barcode-reader';
import ScanningBox from '../ScanningBox';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import Cookies from 'js-cookie';
import { isMobileViewport } from '../../services/device';
import OrderWebSocket from '../../services/orderWebSocket';

const base = 'cooking-v2';
const ONE_SECOND = 1000;
const TEN_MINUTES = 10 * 60 * 1000;
const isMarketplaceDelivery = (platform = '') =>
    ['GrabFood', 'FoodPanda', 'ShopeeFood'].some((marketplace) =>
        (platform || '').includes(marketplace)
    );
const isInOutletItem = (item) =>
    ['DINE_IN', 'TAKE_AWAY', 'PICK_UP', 'PANDU_LALU'].includes(item.pick_up_type) &&
    !isMarketplaceDelivery(item.platform);
const isDeliveryItem = (item) =>
    item.pick_up_type == null ||
    item.pick_up_type === 'DELIVERY' ||
    isMarketplaceDelivery(item.platform);

const createMockCookingItem = (
    sku,
    {
        pickUpType = 'DINE_IN',
        platform = 'PopMeals',
        orderOffsetMs = TEN_MINUTES,
        productionOffsetMs = TEN_MINUTES,
        overrides = {},
    } = {}
) => ({
    sku,
    platform,
    pick_up_type: pickUpType,
    order_date: Date.now() - orderOffsetMs,
    production_started_at: Date.now() - productionOffsetMs,
    status: 'Pending',
    item_type: 'Item',
    category_name: 'Mains',
    today_menu_id: '',
    item_group: null,
    value_meal_items: [],
    not_served_by_insta_service_component_map: null,
    ...overrides,
});

const getMockCookingLayoutData = () => ({
    inOutletNasiNasiItems: [],
    deliveryNasiNasiItems: [],
    incomingNasiNasiItems: [],
    inOutletPastaItems: [],
    deliveryPastaItems: [],
    incomingPastaItems: [],
    inOutletSidesAndDrinks: [
        createMockCookingItem('Hard Boiled Egg', {
            pickUpType: 'DINE_IN',
            orderOffsetMs: 9 * 60 * 1000,
            overrides: { item_type: 'Addons', category_name: 'Sides' },
        }),
        createMockCookingItem('French Fries', {
            pickUpType: 'DINE_IN',
            orderOffsetMs: 9 * 60 * 1000,
            overrides: { item_type: 'Addons', category_name: 'Sides' },
        }),
    ],
    deliverySidesAndDrinks: [
        createMockCookingItem('Ayam Gepuk', {
            platform: 'PopMeals',
            pickUpType: null,
            orderOffsetMs: 50 * 1000,
        }),
        createMockCookingItem('Ayam Gepuk', {
            platform: 'PopMeals',
            pickUpType: null,
            orderOffsetMs: 50 * 1000,
        }),
    ],
    incomingSidesAndDrinks: [],
    instaServiceProductions: [
        {
            id: 'MOCK-TOPUP-1',
            created_date: Date.now() - 6 * 60 * 1000,
            requests: [
                {
                    sku: 'CARB-SAUCE',
                    name: 'Carbonara Sauce',
                    quantity: 2,
                    category: 'Sauces',
                    status: 'PENDING',
                    oos: false,
                    insta_service_location: 'Sous Vide',
                },
                {
                    sku: 'AYAM-GOR-QUARTER',
                    name: 'Ayam Goreng Quarter',
                    quantity: 3,
                    category: 'Protein',
                    status: 'PENDING',
                    oos: false,
                    insta_service_location: 'Warmer',
                },
                {
                    sku: 'THAI-MILK-TEA',
                    name: 'Thai Milk Tea',
                    quantity: 2,
                    category: 'Packet Drinks',
                    status: 'PENDING',
                    oos: false,
                    insta_service_location: 'Chiller',
                },
            ],
        },
    ],
    currentWarmerStocks: [
        {
            sku: 'SAMBAL-GAJUS',
            name: 'Sambal Gajus Scoop',
            category: 'Sambal',
            quantity: 42,
            oos: false,
            insta_service_location: 'Warmer',
        },
        {
            sku: 'SAMBAL-GESEK',
            name: 'Sambal Gesek',
            category: 'Sambal',
            quantity: 15,
            oos: false,
            insta_service_location: 'Warmer',
        },
        {
            sku: 'SAMBAL-MERECIK',
            name: 'Sambal Merecik',
            category: 'Sambal',
            quantity: 5,
            oos: true,
            insta_service_location: 'Warmer',
        },
        {
            sku: 'TENDER-1PC',
            name: 'Tender 1pc',
            category: 'Protein',
            quantity: 8,
            oos: false,
            insta_service_location: 'Warmer',
        },
        {
            sku: 'POPCORN-CHICKEN',
            name: 'Popcorn Chicken Portion',
            category: 'Protein',
            quantity: 7,
            oos: false,
            insta_service_location: 'Warmer',
        },
        {
            sku: 'CHICKEN-SOUP',
            name: 'Chicken Soup',
            category: 'Cooked Items',
            quantity: 5,
            oos: false,
            insta_service_location: 'Sous Vide',
        },
        {
            sku: 'BANDUNG-VANILLA',
            name: 'Bandung Vanilla',
            category: 'Packet Drinks',
            quantity: 2,
            oos: false,
            insta_service_location: 'Chiller',
        },
    ],
});

@inject('OrdersKitchenStore', 'UserStore', 'LiveDispatchStore', 'ScanningStore')
@observer
class CookingV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFullscreen: false,
            pages:[],
            webSocketConnected: true
        };
        this.webcamRef = React.createRef();
        this.pollingInterval = null;
        this.isAndroidTvWebView = false;
    }

    componentDidMount() {
        const {
            OrdersKitchenStore: {
                handleGetInstaServiceProductions,
            },
            UserStore,
            location,
        } = this.props;

        // Extract token and hub_code from URL parameters
        const parameters = qs.parse(location.search.slice(1));
        const { token, hub_code: hubCode } = parameters;
        const useMockCookingLayoutData = parameters.mock_cooking_layout === '1';
        const hasUrlAuth = !!(token && hubCode) || useMockCookingLayoutData;

        // If token and hub_code are in URL, set them for authentication
        if (token && hubCode) {
            UserStore.handleGetHubs().then(() => {
                UserStore.setAuthentication(token, hubCode);
            });
            Cookies.set('token', token);
            UserStore.authedUser = token;
        }

        const {
            selectedHub: { isOnDemandProduction } = {},
            handleSetFullscreen,
            position
        } = UserStore;

        let pages = [
            'inventory',
            'packing',
            'cooking',
            'insta-service',
            'attendance-scan',
            'all-orders',
            'operation-dashboard'
        ];

        if (["Territory Manager", "Business Manager", "Outlet Manager"].includes(position)) {
            pages.push('partner-management');
        }

        this.setState({pages: pages})

        if (!isMobileViewport()) {
            handleSetFullscreen(true)
        }
        if (isOnDemandProduction || hasUrlAuth) {
            handleGetInstaServiceProductions(true, token || null, hubCode || null);
        }

        // Detect Android TV WebView so we can neutralize forced font scaling with CSS.
        if (typeof navigator !== 'undefined') {
            const userAgent = navigator.userAgent || '';
            const isAndroidDevice = userAgent.includes('Android');
            const isTvDevice = /Android TV|BRAVIA|AFT|ADT-|SHIELD/.test(userAgent);
            const isWebView = userAgent.includes('; wv') || /Version\/\d+\.\d+/.test(userAgent);

            if (isAndroidDevice && isTvDevice && isWebView && typeof document !== 'undefined') {
                document.documentElement.classList.add('android-tv-webview');
                this.isAndroidTvWebView = true;
            }
        }
    }

    startPolling = () => {
        if (this.pollingInterval) {
            return;
        }

        const {
            OrdersKitchenStore: {
                handleGetDeliveryOrders,
                handleGetDineInOrders,
                handleGetInstaServiceProductions,
            },
            UserStore
        } = this.props;

        const {selectedHub: { isOnDemandProduction } = {}} = UserStore;

        if (isOnDemandProduction) {
            handleGetDineInOrders(true);
            handleGetDeliveryOrders(true);
            handleGetInstaServiceProductions(true);

            this.pollingInterval = setInterval(() => {
                handleGetDineInOrders(false);
                handleGetDeliveryOrders(false);
                handleGetInstaServiceProductions(false);
            }, 10 * ONE_SECOND);
        }
    };

    stopPolling = () => {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    };

    handleWebSocketConnectionChange = (connected) => {
        this.setState({ webSocketConnected: connected });

        if (!connected) {
            this.startPolling();
        } else {
            this.stopPolling();
        }
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        clearInterval(this.pollingInterval);
        if (this.isAndroidTvWebView && typeof document !== 'undefined') {
            document.documentElement.classList.remove('android-tv-webview');
            this.isAndroidTvWebView = false;
        }
    }

    handleError = (err) => {};

    handleScanWrapper = (scannedBarcode) => {
        const { LiveDispatchStore, ScanningStore } = this.props;
        const { setItemImage, handledScannedItem, handledScannedBag, handledScannedWarmerItem, displayErrorResultFunc } =
            LiveDispatchStore;
        const { handleScan } = ScanningStore;
        if (this.webcamRef.current) {
            const image = this.webcamRef.current.getScreenshot();
            setItemImage(image);
        }
        let isBagQRCode = scannedBarcode.split('-').length == 1;
        if (isBagQRCode) {
            handledScannedBag(scannedBarcode);
        } else {
            handleScan(scannedBarcode, handledScannedItem, handledScannedWarmerItem, displayErrorResultFunc);
        }
    };

    handleSetPage = (page) => {
        const {
            history,
            UserStore: { setPage },
        } = this.props;

        setPage(page);
        history.push(`/${page}`);
    };

    render() {
        const { LiveDispatchStore, OrdersKitchenStore, UserStore, location } = this.props;
        const {
            isCurrentPageFullScreen: isFullscreen,
            handleSetFullscreen,
            handleExitFullscreen,
            selectedHub: { isOnDemandProduction } = {},
        } = UserStore;

        // Extract token and hub_code from URL to determine if we should render
        const parameters = qs.parse(location.search.slice(1));
        const { token, hub_code: hubCode } = parameters;
        const useMockCookingLayoutData = parameters.mock_cooking_layout === '1';
        const hasUrlAuth = (token && hubCode) || useMockCookingLayoutData;

        const {
            deliveryOrders = [],
            dineInOrders = [],
            deliveryOrdersLoading,
            dineInOrdersLoading,
            inCartItems = [],
            instaServiceProductions = [],
            currentWarmerStocks = [],
            updateOrderData
        } = OrdersKitchenStore;

        const {
            itemImage: image,
            itemScanLoading,
            scannedItem,
            scannedItemSKU,
            scannedItemError,
            showScannedItemOnLiveDispatch,
            originalItemImageLink,
        } = LiveDispatchStore;

        const {
            pages
        } = this.state;

        const allOrders = [...dineInOrders, ...deliveryOrders]
            .filter((order) => order.status === 'Pending' && order.production_started_at)
            .sort((a, b) => a.order_date - b.order_date);

        const processItems = (items) => {
            const enrichedItems = items.map((item) => {
                const group = item.item_group?.toString();
                const isMainItem = !group || group.endsWith('.0');
                return {
                ...item,
                item_group_str: group,
                isMainItem,
                };
            });

            enrichedItems.sort((a, b) => {
                const parseGroup = (group) => {
                if (!group) return [Infinity, Infinity];
                return group.split('.').map(Number);
                };
                const [aMajor, aMinor] = parseGroup(a.item_group_str);
                const [bMajor, bMinor] = parseGroup(b.item_group_str);
                if (aMajor !== bMajor) return aMajor - bMajor;
                return aMinor - bMinor;
            });

            return enrichedItems.map((item, index, arr) => {
                const next = arr[index + 1];
                const lastItemOfGroup = !next || next.isMainItem;

                let value_meal_items = [];
                if (item.isMainItem && item.item_group_str) {
                const prefix = item.item_group_str.split('.')[0];
                value_meal_items = arr.filter(other =>
                    other.item_group_str &&
                    other.item_group_str.startsWith(prefix + '.') &&
                    !other.item_group_str.endsWith('.0') &&
                    other.item_group_str !== item.item_group_str
                );
                }

                return {
                ...item,
                lastItemOfGroup,
                value_meal_items,
                };
            });
        };

        const processedInCartItems = processItems(inCartItems);
        const getProcessedOrderItemsWithContext = (order) =>
            processItems(order.items || []).map((item) => ({
                ...item,
                pick_up_type: item.pick_up_type || order.order_mode,
                order_mode: item.order_mode || order.order_mode,
                delivery_time: item.delivery_time || order.delivery_time,
                customer_self_pickup_at_outlet:
                    item.customer_self_pickup_at_outlet != null
                        ? item.customer_self_pickup_at_outlet
                        : order.customer_self_pickup_at_outlet,
                order_date: item.order_date || order.order_date,
                created_date: item.created_date || order.created_date,
                production_started_at:
                    item.production_started_at || order.production_started_at,
                platform:
                    item.platform ||
                    order.platform ||
                    order.sale_platform ||
                    '',
                sale_platform:
                    item.sale_platform ||
                    order.sale_platform ||
                    item.platform ||
                    '',
            }));

        const inOutletNasiNasiItems = allOrders.flatMap(order => {
            const sortedItems = getProcessedOrderItemsWithContext(order);
            return sortedItems.filter(item => 
                item.nasi_nasi_nasi_category && 
                item.status != 'ON_ROUTE' &&
                isInOutletItem(item))
        });

        const deliveryNasiNasiItems = allOrders.flatMap(order => {
            const sortedItems = getProcessedOrderItemsWithContext(order);
            return sortedItems.filter(item => (item.nasi_nasi_nasi_category && 
                item.status != 'ON_ROUTE' &&
                isDeliveryItem(item)))
        });

        const incomingNasiNasiItems = processedInCartItems.filter(item => (item.nasi_nasi_nasi_category));

        const inOutletPastaItems = allOrders.flatMap(order => {
            const sortedItems = getProcessedOrderItemsWithContext(order);
            return sortedItems.filter(item => 
                (item.item_type == 'Item' &&
                item.today_menu_id != "CUTLERY" &&
                item.status != 'ON_ROUTE' &&
                !item.nasi_nasi_nasi_category && 
                isInOutletItem(item)))
        });

        const deliveryPastaItems = allOrders.flatMap(order => {
            const sortedItems = getProcessedOrderItemsWithContext(order);
            return sortedItems.filter(item => 
                (item.item_type == 'Item' && 
                item.today_menu_id != "CUTLERY" &&
                item.status != 'ON_ROUTE' &&
                !item.nasi_nasi_nasi_category && 
                isDeliveryItem(item)
                ))
        });

        const incomingPastaItems = processedInCartItems.filter(item => (item.item_type == 'Item' && 
            item.today_menu_id != "CUTLERY" && 
            !item.nasi_nasi_nasi_category));

        const inOutletSides = allOrders.flatMap(order => 
            getProcessedOrderItemsWithContext(order).filter(item => 
                (((item.item_type == "Addons" && item.category_name !== 'Drinks' && item.item_group == null) ||
                    item.today_menu_id == "CUTLERY") &&
                item.status != 'ON_ROUTE' &&
                isInOutletItem(item)))
        );

        const deliverySides = allOrders.flatMap(order => 
            getProcessedOrderItemsWithContext(order).filter(item => 
                (((item.item_type == "Addons" && item.category_name !== 'Drinks' && item.item_group == null) ||
                    item.today_menu_id == "CUTLERY") &&
                item.status != 'ON_ROUTE' &&
                    isDeliveryItem(item)))
        );

        const incomingSides = processedInCartItems.filter(item => ((item.item_type == "Addons" && 
            item.category_name !== 'Drinks') ||
            item.today_menu_id == "CUTLERY") && 
            item.item_group == null);

        const inOuteltDrinks = allOrders.flatMap(order => 
            getProcessedOrderItemsWithContext(order).filter(item => 
                (item.category_name == 'Drinks' && 
                item.status != 'ON_ROUTE'  && item.item_group == null &&
                isInOutletItem(item)))
        );

        const deliveryDrinks = allOrders.flatMap(order => 
            getProcessedOrderItemsWithContext(order).filter(item => 
                (item.category_name == 'Drinks' && 
                item.status != 'ON_ROUTE' && item.item_group == null &&
                isDeliveryItem(item)))
        );

        const incomingDrinks = processedInCartItems.filter(item => (item.category_name == 'Drinks' && item.item_group == null));
        const inOutletSidesAndDrinks = [...inOutletSides, ...inOuteltDrinks];
        const incomingSidesAndDrinks = [...incomingSides, ...incomingDrinks];
        const deliverySidesAndDrinks = [...deliverySides, ...deliveryDrinks];
        const displayData = useMockCookingLayoutData
            ? getMockCookingLayoutData()
            : {
                inOutletNasiNasiItems,
                deliveryNasiNasiItems,
                incomingNasiNasiItems,
                inOutletPastaItems,
                deliveryPastaItems,
                incomingPastaItems,
                inOutletSidesAndDrinks,
                deliverySidesAndDrinks,
                incomingSidesAndDrinks,
                instaServiceProductions: instaServiceProductions || [],
                currentWarmerStocks: currentWarmerStocks || [],
            };

        const {
            inOutletNasiNasiItems: displayInOutletNasiNasiItems,
            deliveryNasiNasiItems: displayDeliveryNasiNasiItems,
            incomingNasiNasiItems: displayIncomingNasiNasiItems,
            inOutletPastaItems: displayInOutletPastaItems,
            deliveryPastaItems: displayDeliveryPastaItems,
            incomingPastaItems: displayIncomingPastaItems,
            inOutletSidesAndDrinks: displayInOutletSidesAndDrinks,
            deliverySidesAndDrinks: displayDeliverySidesAndDrinks,
            incomingSidesAndDrinks: displayIncomingSidesAndDrinks,
            instaServiceProductions: displayInstaServiceProductions,
            currentWarmerStocks: displayCurrentWarmerStocks,
        } = displayData;

        return (
            <Fullscreen
                enabled={isFullscreen}
                onChange={(isFullscreen) => {
                    if (isFullscreen) {
                        handleSetFullscreen(isFullscreen);
                    } else {
                        handleExitFullscreen();
                    }
                }}
            >
                <Helmet>
                    <title>Cooking V2 | Outlet OS | Pop Meals</title>
                </Helmet>
                <OrderWebSocket
                        updateOrderData={updateOrderData}
                        onConnectionChange={this.handleWebSocketConnectionChange}
                />
                <div
                    style={{
                        position: 'fixed',
                        bottom: 12,
                        left: 12,
                        zIndex: 9999,
                        padding: '6px 12px',
                        borderRadius: 14,
                        fontSize: 12,
                        fontWeight: 600,
                        color: '#fff',
                        background: this.state.webSocketConnected ? '#2e7d32' : '#c62828'
                    }}
                >
                    Status: {this.state.webSocketConnected ? 'Connected' : 'Disconnected'}
                </div>
                {(isOnDemandProduction || hasUrlAuth) && (
                    <div className={`${base} width--100`}>
                        <div className={`${base}__webcam-area`}>
                            <Webcam
                                audio={false}
                                ref={this.webcamRef}
                                screenshotFormat="image/jpeg"
                                className="webcam"
                                screenshotQuality={1}
                                forceScreenshotSourceSize={true}
                                videoConstraints={{
                                    height: 1080,
                                    width: 1920,
                                }}
                            />
                        </div> 
                        {(dineInOrdersLoading || deliveryOrdersLoading) && !useMockCookingLayoutData ? (
                            <Loading />
                        ) : (
                            <div>
                                <div className={`${base}__table ${isFullscreen ? `${base}__table_full_screen` : ''}`}>
                                    <div className={`${base}__main_bar`}>
                                        <div className={`${base}__main_bar_column`}>
                                            NASI
                                        </div>
                                        <div className={`${base}__main_bar_column`}>
                                            PASTA
                                        </div>
                                        <div className={`${base}__main_bar_column`}>
                                            DRINKS & SIDES
                                        </div>
                                        <div className={`${base}__main_bar_column ${base}__main_bar_column_actions`}>
                                            <div className={`${base}__main_bar_title`}>
                                                INSTASERVICE
                                            </div>
                                            <div className={`${base}__main_bar_controls`}>
                                                <button
                                                    className={`${base}__fullscreen_btn`}
                                                    onClick={() => handleSetFullscreen(!isFullscreen)}
                                                >
                                                    <img
                                                        className={`${base}__exit_fullscreen_icon`}
                                                        src={isFullscreen? "https://image.popcontent.link/exit-full-screen.png" : "https://image.popcontent.link/go_full_screen.png"}
                                                            alt="Exit fullscreen"
                                                    />
                                                </button>
                                                {isFullscreen && (
                                                    <div className={`${base}__dropdown `}>
                                                        <svg fill="#fff" className="iconmoon-icon">
                                                            <use xlinkHref={`#icon-caret-down`} />
                                                        </svg>
                                                        <div className={`dropdown-content pages`}>
                                                            {pages
                                                                .map((page, i) => (
                                                                    <a
                                                                        key={i}
                                                                        className="cursor-pointer"
                                                                        onClick={() =>
                                                                            this.handleSetPage(page)
                                                                        }
                                                                    >
                                                                        {page}
                                                                    </a>
                                                                ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${base}__columns`}>
                                    <div
                                        className={isFullscreen ? `${base}__item_column_full_screen` : `${base}__item_column`}
                                    >
                                        {((displayInOutletNasiNasiItems &&
                                            displayInOutletNasiNasiItems.length > 0) ||
                                            (displayIncomingNasiNasiItems &&
                                                displayIncomingNasiNasiItems.length > 0)) && (
                                                <InOutletSubHeadingWrapper
                                                    haveInOutletOrders = {displayInOutletNasiNasiItems && displayInOutletNasiNasiItems.length > 0}/>
                                            )
                                        }
                                        {displayInOutletNasiNasiItems &&
                                            displayInOutletNasiNasiItems.length > 0 &&
                                            displayInOutletNasiNasiItems.map((item) => (
                                                <OrderCategoryItems
                                                    item = {item}
                                                />
                                        ))}
                                        {displayIncomingNasiNasiItems && displayIncomingNasiNasiItems.length > 0 && (
                                            <IncomingItems items = {displayIncomingNasiNasiItems} />
                                        )}
                                        {displayDeliveryNasiNasiItems &&
                                        displayDeliveryNasiNasiItems.length > 0  && (
                                            <DeliverySubHeadingWrapper />
                                            )
                                        }
                                        {displayDeliveryNasiNasiItems &&
                                            displayDeliveryNasiNasiItems.length > 0 &&
                                            displayDeliveryNasiNasiItems.map((item) => (
                                                <OrderCategoryItems
                                                    item = {item}
                                                />
                                        ))}
                                    </div>
                                    <div
                                        className={isFullscreen ? `${base}__item_column_full_screen` : `${base}__item_column`}
                                    >
                                        {((displayInOutletPastaItems &&
                                            displayInOutletPastaItems.length > 0) ||
                                            (displayIncomingPastaItems &&
                                                displayIncomingPastaItems.length > 0)) && (
                                                <InOutletSubHeadingWrapper
                                                    haveInOutletOrders = {displayInOutletPastaItems && displayInOutletPastaItems.length > 0}/>
                                            )
                                        }
                                        {displayInOutletPastaItems &&
                                            displayInOutletPastaItems.length > 0 &&
                                            displayInOutletPastaItems.map((item) => (
                                                <OrderCategoryItems
                                                    item = {item}
                                                />
                                            ))}
                                        {displayIncomingPastaItems && displayIncomingPastaItems.length > 0 && (
                                            <IncomingItems items = {displayIncomingPastaItems} />
                                        )}
                                        {displayDeliveryPastaItems &&
                                        displayDeliveryPastaItems.length > 0 && (
                                            <DeliverySubHeadingWrapper />
                                            )
                                        }
                                        {displayDeliveryPastaItems &&
                                            displayDeliveryPastaItems.length > 0 &&
                                            displayDeliveryPastaItems.map((item) => (
                                                <OrderCategoryItems
                                                    item = {item}
                                                />
                                        ))}
                                    </div>
                                    <div
                                        className={isFullscreen ? `${base}__item_column_full_screen` : `${base}__item_column`}
                                    >
                                        {((displayInOutletSidesAndDrinks &&
                                            displayInOutletSidesAndDrinks.length > 0) ||
                                            (displayIncomingSidesAndDrinks &&
                                                displayIncomingSidesAndDrinks.length > 0)) && (
                                                <InOutletSubHeadingWrapper
                                                    haveInOutletOrders = {displayInOutletSidesAndDrinks && displayInOutletSidesAndDrinks.length > 0}/>
                                            )
                                        }
                                        {displayInOutletSidesAndDrinks &&
                                            displayInOutletSidesAndDrinks.length > 0 &&
                                            displayInOutletSidesAndDrinks.map((item) => (
                                                <OrderCategoryItems
                                                    item = {item}
                                                />
                                        ))}
                                        {displayIncomingSidesAndDrinks && displayIncomingSidesAndDrinks.length > 0 && (
                                            <IncomingItems items = {displayIncomingSidesAndDrinks} />
                                        )}
                                        {displayDeliverySidesAndDrinks &&
                                        displayDeliverySidesAndDrinks.length > 0 && (
                                            <DeliverySubHeadingWrapper />
                                            )
                                        }
                                        {displayDeliverySidesAndDrinks &&
                                            displayDeliverySidesAndDrinks.length > 0 &&
                                            displayDeliverySidesAndDrinks.map((item) => (
                                                <OrderCategoryItems
                                                    item = {item}
                                                />
                                        ))}
                                    </div>
                                    <div
                                        className={isFullscreen ? `${base}__item_column_full_screen` : `${base}__item_column`}
                                    >
                                        <div className={`${base}__insta_service_column`}>
                                            <div className={`${base}__insta_service_pending_panel`}>
                                                <InstaServiceProduction
                                                    instaServiceProductions={displayInstaServiceProductions}
                                                />
                                            </div>
                                            <div className={`${base}__insta_service_current_stock_panel`}>
                                                <InstaServiceCurrentStock
                                                    currentWarmerStocks={displayCurrentWarmerStocks}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <BarcodeReader
                    onError={this.handleError}
                    onScan={this.handleScanWrapper}
                />
                <ScanningBox
                    show={showScannedItemOnLiveDispatch}
                    scannedItem={scannedItem}
                    scannedItemSKU={scannedItemSKU}
                    scannedItemError={scannedItemError}
                    handleScan={this.handleScanWrapper}
                    loading={itemScanLoading}
                    originalItemImageLink={originalItemImageLink}
                    itemImage={image}
                    isCurrentPageFullScreen={isFullscreen}
                />
            </Fullscreen>
        );
    }
}

export default withRouter(CookingV2);
